// C:\Users\User\Desktop\Bresco\bresco-franquicies-frontend\src\components\layout\Sidebar\Sidebar.js
import logoNuevo from 'assets/img/favicon.png'
import Menu from 'components/layout/Menu/Menu'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu'
import { useLocation } from 'wouter'

export default function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  const [location] = useLocation()
  const prevLocation = useRef(location)

  // DEBUG: Detectar cambios en isSidebarOpen
  useEffect(() => {
    // console.log('🔍 Sidebar state changed:', isSidebarOpen)
  }, [isSidebarOpen])

  // Cerrar sidebar SOLO en móvil cuando cambia la ruta
  useEffect(() => {
    if (prevLocation.current !== location) {
      // console.log('🚀 Navegación detectada:', prevLocation.current, '->', location)
      
      const isMobile = window.innerWidth < 768
      // console.log('📱 ¿Es móvil?:', isMobile, '| Ancho:', window.innerWidth)
      
      if (isMobile && isSidebarOpen) {
        // console.log('✅ Cerrando sidebar en móvil')
        setIsSidebarOpen(false)
      } else {
        // console.log('❌ NO se cierra el sidebar (desktop o ya cerrado)')
      }
      
      prevLocation.current = location
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <>
      {/* SIDEBAR DESKTOP */}
      <aside
        id="sidebar-desktop"
        className={`fixed top-0 left-0 z-20 h-screen font-normal transition-width duration-100 ${
          isSidebarOpen
            ? 'hidden md:flex md:flex-col md:flex-shrink-0 w-0 md:w-60'
            : 'hidden md:flex md:flex-col md:flex-shrink-0 w-0 md:w-20'
        }`}
        aria-label="Sidebar Desktop"
      >
        <div className="relative flex flex-col flex-1 min-h-0 bg-[#5362AC] dark:bg-[#38393D]">
          <div
            className={`px-3 py-4 flex justify-between ${
              isSidebarOpen ? 'flex-row items-center' : 'flex-col items-start space-y-5'
            }`}
          >
            <div title="Gestinet" className="inline-flex pl-1 text-base text-white duration-75">
              <img
                className={`block float-left duration-500 bg-white rounded-full w-12 min-w-12 max-w-12 ${
                  isSidebarOpen && 'rotate-[360deg]'
                }`}
                src={logoNuevo}
                alt=""
              />
            </div>
            {!isSidebarOpen ? (
              <div className="w-full pl-3">
                <LuPanelLeftOpen
                  title="Desplegar menú"
                  className="text-white cursor-pointer hover:text-[#FCAE52] duration-300"
                  size={26}
                  onClick={() => {
                    // console.log('👆 Click en ABRIR sidebar')
                    setIsSidebarOpen(true)
                  }}
                />
              </div>
            ) : (
              <div className="w-auto">
                <LuPanelLeftClose
                  title="Plegar menú"
                  className="text-white cursor-pointer hover:text-[#FCAE52] duration-300"
                  size={26}
                  onClick={() => {
                    // console.log('👆 Click en CERRAR sidebar')
                    setIsSidebarOpen(false)
                  }}
                />
              </div>
            )}
          </div>
          <ul
            id="scrollable-sidebar"
            className="pl-1.5 pr-2 py-3 space-y-2 overflow-y-scroll overflow-x-hidden grow border-t-2 border-dashed border-[#FCAE52] font-medium"
          >
            <Menu isSidebarOpen={isSidebarOpen} />
          </ul>
        </div>
      </aside>

      {/* SIDEBAR MÓVIL */}
      <aside
        id="sidebar-mobile"
        className={`fixed top-0 left-0 z-20 h-screen flex flex-col flex-shrink-0 font-normal transition-width duration-100 ${
          isSidebarOpen ? 'md:hidden w-9/12 sm:w-6/12 md:w-60' : 'w-0 overflow-hidden'
        }`}
        aria-label="Sidebar Mobile"
      >
        <div className="relative flex flex-col flex-1 min-h-0 px-3 py-4 bg-[#5362AC]">
          <div
            className={`flex items-center justify-between duration-300 ${
              isSidebarOpen ? 'flex-row-reverse' : 'flex-col space-y-8 pt-2.5'
            }`}
          >
            {!isSidebarOpen ? (
              <LuPanelLeftOpen
                className="text-white cursor-pointer hover:text-[#FCAE52]"
                size={30}
                onClick={() => {
                  // console.log('👆 Click en ABRIR sidebar (móvil)')
                  setIsSidebarOpen(true)
                }}
              />
            ) : (
              <LuPanelLeftClose
                className="text-white cursor-pointer hover:text-[#FCAE52]"
                size={30}
                onClick={() => {
                  // console.log('👆 Click en CERRAR sidebar (móvil)')
                  setIsSidebarOpen(false)
                }}
              />
            )}
            <div className="inline-flex pl-1 text-base text-white">
              <img
                className={`block float-left duration-500 bg-white rounded-full w-12 min-w-12 max-w-12 p-1 ${
                  isSidebarOpen && 'rotate-[360deg]'
                }`}
                src={logoNuevo}
                loading="lazy"
                alt="Gestinet"
              />
            </div>
          </div>
          <ul
            id="scrollable-sidebar"
            className="pt-4 pl-0.5 space-y-2 overflow-x-hidden overflow-y-scroll grow font-medium"
          >
            <Menu isSidebarOpen={isSidebarOpen} />
          </ul>
        </div>
      </aside>

      {/* OVERLAY para cerrar en móvil */}
      <div
        className={`${
          isSidebarOpen ? 'md:hidden' : 'hidden'
        } duration-1000 fixed z-10 w-screen h-screen bg-black bg-opacity-60`}
        onClick={() => {
          // console.log('👆 Click en OVERLAY (cerrar móvil)')
          setIsSidebarOpen(false)
        }}
      ></div>
    </>
  )
}

Sidebar.propTypes = {
  isSidebarOpen: PropTypes.bool,
  setIsSidebarOpen: PropTypes.func
}